import { apiSuppliers } from './apiSuppliers'
import { apiSuppliersPriceLists } from './apiSuppliersPriceLists'
import { apiSuppliersProducts } from './apiSuppliersProducts'
import { apiSuppliersMatchProducts } from './apiSuppliersMatchProducts'
import { apiSuppliersPurchaseConditions } from './apiSuppliersPurchaseConditions'

const apiSupplier = {
	...apiSuppliers,
	...apiSuppliersPriceLists,
	...apiSuppliersProducts,
	...apiSuppliersMatchProducts,
	...apiSuppliersPurchaseConditions,
}

export { apiSupplier }
